import React from 'react';
import ReactDOM from 'react-dom';

import config from '@config';
import { makeServer } from '@mirage';

import Root from './Root';

if (config.withFakeApi) {
  makeServer({ environment: 'development' });
}

ReactDOM.render(<Root />, document.getElementById('root'));
